<script setup>
import { ref } from 'vue';

import CalendarIcon from "../../assets/calendar.png";
import ShieldIcon from "../../assets/shield.png";
import BillIcon from "../../assets/bill.png";
import UmbrellaIcon from "../../assets/umbrella.png";

import AdvantageCard from './advantage-card.vue';

const cards = ref([
    {
        icon: CalendarIcon,
        title: "business.advantages.cards.first.title",
        subtitle: "business.advantages.cards.first.subtitle"
    }, {
        icon: ShieldIcon,
        title: "business.advantages.cards.second.title",
        subtitle: "business.advantages.cards.second.subtitle"
    }, {
        icon: BillIcon,
        title: "business.advantages.cards.third.title",
        subtitle: "business.advantages.cards.third.subtitle"
    }, {
        icon: UmbrellaIcon,
        title: "business.advantages.cards.fourth.title",
        subtitle: "business.advantages.cards.fourth.subtitle"
    }
])
</script>

<template>
    <div class="advantages">
        <h2 class="title">{{ $t("business.advantages.title") }}</h2>

        <div class="cards">
            <div v-for="card in cards">
                <AdvantageCard
                    v-bind="card"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>
.advantages {
    margin-top: 100px;
}

.title {
    color: #373737;

    text-transform: uppercase;
    text-align: center;

    font-size: 30px;
    font-weight: 700;
}

.cards {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;

    gap: 20px;
    margin-top: 50px;
}

@media screen and (max-width: 1280px) {
    .cards {
        overflow-x: scroll;
        max-width: 100vw;
        padding: 0 20px;

        margin-top: 35px;
    }

    .advantages {
        margin-top: 70px;
    }
}
</style>